var _ellipse, _ellipse2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveUserGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.66667,
    cy: 11.6667,
    rx: 4.66667,
    ry: 2.33333,
    stroke: "#133696",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.66667,
    cy: 4.66667,
    rx: 2.66667,
    ry: 2.66667,
    stroke: "#133696",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1858 6.56965C9.9003 7.09662 9.49984 7.55224 9.01807 7.9029C9.32301 8.0195 9.65402 8.08337 9.99995 8.08337C11.5187 8.08337 12.75 6.85216 12.75 5.33337C12.75 3.84226 11.5632 2.62833 10.0827 2.58459C10.387 3.08285 10.5854 3.65289 10.6465 4.26338C11.0082 4.48241 11.25 4.87966 11.25 5.33337C11.25 5.96056 10.788 6.47986 10.1858 6.56965Z",
    fill: "#133696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1309 13.1835C12.4751 12.7213 12.6668 12.2077 12.6668 11.6667C12.6668 11.5892 12.6628 11.5122 12.6551 11.4358C12.8985 11.3236 13.0623 11.2101 13.1594 11.1145C13.2195 11.0553 13.2409 11.0172 13.248 11C13.2409 10.9829 13.2195 10.9447 13.1594 10.8856C13.0478 10.7756 12.8477 10.642 12.5401 10.5138C12.4692 10.4843 12.3944 10.4558 12.3161 10.4286C11.8674 9.6641 11.015 9.01717 9.91602 8.58371C9.944 8.58349 9.97203 8.58337 10.0001 8.58337C11.1789 8.58337 12.2814 8.78104 13.117 9.12922C13.5332 9.30263 13.9189 9.52819 14.2121 9.81701C14.5079 10.1084 14.7501 10.5087 14.7501 11C14.7501 11.4914 14.5079 11.8917 14.2121 12.1831C13.9189 12.4719 13.5332 12.6975 13.117 12.8709C12.8193 12.9949 12.4877 13.0998 12.1309 13.1835ZM13.2512 11.0105C13.2511 11.0105 13.2507 11.0093 13.2504 11.0067C13.2512 11.0093 13.2513 11.0105 13.2512 11.0105ZM13.2504 10.9933C13.2507 10.9908 13.2511 10.9895 13.2512 10.9895C13.2513 10.9895 13.2512 10.9908 13.2504 10.9933Z",
    fill: "#133696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUserGroup);
export default __webpack_public_path__ + "static/media/activeUserGroup.a21627996ac1f7d7a87f8584070472c0.svg";
export { ForwardRef as ReactComponent };